<div class="row">
  <div class="col-12">
    <div class="card border-0 shadow-sm mb-4 tuc-card">

      <!-- Header -->
      <div class="card-header bg-white border-0 pt-4 pb-3 px-4">
        <div class="d-flex align-items-center gap-3">
          <div class="tuc-icon-badge">
            <i class="fa fa-exchange-alt"></i>
          </div>
          <div>
            <h5 class="mb-0 fw-bold text-dark">Transferencia de Unión Crédito</h5>
            <small class="text-muted">Procesos</small>
          </div>
        </div>
      </div>

      <div class="card-body px-4 pb-4">
        <form [formGroup]="form_data_union" (ngSubmit)="onSendData()">
          <div class="container col-lg-9 mx-auto">

            <!-- Ejercicio / Semana -->
            <div class="row g-3 mb-3">
              <div class="col-md-6">
                <label class="form-label fw-semibold tuc-label">
                  <i class="fa fa-calendar-alt me-1 text-primary"></i> Ejercicio
                </label>
                <select id="id" class="form-select tuc-input" (change)="selectYear()"
                    formControlName="ejercicio" required>
                  <option value="">Seleccione año</option>
                  <option *ngFor="let component of ListaAnios" [value]="component">
                    {{component}}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label fw-semibold tuc-label">
                  <i class="fa fa-calendar-week me-1 text-primary"></i> Semana
                </label>
                <select id="id" class="form-select tuc-input" (change)="selectWeek()"
                    formControlName="semana" required>
                  <option value="">Seleccione semana</option>
                  <option *ngFor="let component of ListaSemanas" [value]="component">
                    {{component}}</option>
                </select>
              </div>
            </div>

            <!-- Rango de fechas -->
            <div class="tuc-date-range mb-4">
              <div class="row align-items-center g-3">
                <div class="col-md-6">
                  <div class="d-flex align-items-center gap-2">
                    <span class="tuc-date-dot"></span>
                    <div class="flex-grow-1">
                      <label class="form-label fw-semibold tuc-label mb-1">Del</label>
                      <input class="form-control tuc-input" type="date" [value]="inicio" readonly>
                      <input type="text" [ngModel]="inicio" formControlName="fechaIni" readonly hidden>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex align-items-center gap-2">
                    <span class="tuc-date-dot tuc-date-dot-end"></span>
                    <div class="flex-grow-1">
                      <label class="form-label fw-semibold tuc-label mb-1">Al</label>
                      <input class="form-control tuc-input" type="date" [value]="final" readonly>
                      <input type="text" [ngModel]="final" formControlName="fechaFin" readonly hidden>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tipo de liquidación -->
            <div class="mb-4">
              <label class="form-label fw-semibold tuc-label d-block mb-2">
                <i class="fa fa-file-invoice-dollar me-1 text-primary"></i> Tipo de liquidación
              </label>
              <div class="tuc-segmented"     role="group">
                <input type="radio" class="btn-check" id="liqPrevia" autocomplete="off"
                    formControlName="tipoLiquidacion" name="tipoLiquidacion" value="previa">
                <label class="tuc-segment-btn" for="liqPrevia">
                  <i class="fa fa-hourglass-half me-1"></i> Previa
                </label>

                <input type="radio" class="btn-check" id="liqDefinitiva" autocomplete="off"
                    formControlName="tipoLiquidacion" name="tipoLiquidacion" value="definitiva">
                <label class="tuc-segment-btn" for="liqDefinitiva">
                  <i class="fa fa-check-circle me-1"></i> Definitiva
                </label>
              </div>
            </div>

            <!-- Botones -->
            <div class="row g-2 justify-content-center pt-2">
              <div class="col-md-5 d-grid">
                <button type="submit" class="btn tuc-btn-primary">
                  <i class="fa fa-cogs me-1"></i> Generar Archivos
                </button>
              </div>
              <div class="col-md-5 d-grid d-none">
                <button type="button" class="btn btn-secondary" (click)="transfer()">Transferir</button>
              </div>
              <div class="col-md-5 d-grid">
                <button type="button" class="btn tuc-btn-outline" (click)="clean()">
                  <i class="fa fa-eraser me-1"></i> Limpiar
                </button>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>